module.exports = __webpack_public_path__ + "img/03-thu-logo.76e444eb.png";